var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-2 mt-2"},[_c('creator-stats')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }